<payee-popup
  [heading]="'PASSWORD_RESET_DIALOG.TITLE' | translate"
  [description]="'PASSWORD_RESET_DIALOG.DESCRIPTION' | translate"
>
  <form [formGroup]="passwordForm">
    <payee-form-field width="max">
      <span payee-label>{{ "PASSWORD_RESET_DIALOG.OLD_PASSWORD_LABEL" | translate }}</span>
      <input
        payee-input
        type="password"
        autocomplete="current-password"
        [formControl]="oldPwd"
      />
      @if (oldPwd.valid) {
        <div payee-suffix>
          <payee-icon name="checkmark-darker-green-circle"></payee-icon>
        </div>
      }
      @if (oldPwd.dirty) {
        <ng-container payee-error>
          @if (oldPwd.hasError("required")) {
            <mat-error>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</mat-error>
          }
          @if (oldPwd.hasError("minlength") && !oldPwd.hasError("required")) {
            <mat-error>{{ "ERROR_MESSAGES.PASSWORD_MIN_LENGTH" | translate }}</mat-error>
          }
        </ng-container>
      }
      @if (oldPwd.hasError("wrongPassword")) {
        <ng-container payee-error>
          <mat-error>{{ "PASSWORD_RESET_DIALOG.ERROR_MESSAGES.OLD_PASSWORD_WRONG" | translate }}</mat-error>
        </ng-container>
      }
    </payee-form-field>

    <payee-form-field width="max">
      <span payee-label>{{ "PASSWORD_RESET_DIALOG.NEW_PASSWORD_LABEL" | translate }}</span>
      <input
        payee-input
        type="password"
        autocomplete="new-password"
        [formControl]="newPwd"
      />
      @if (newPwd.valid) {
        <div payee-suffix>
          <payee-icon name="checkmark-darker-green-circle"></payee-icon>
        </div>
      }
      @if (newPwd.dirty) {
        <ng-container payee-error>
          @if (newPwd.hasError("required")) {
            <mat-error>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</mat-error>
          }
          @if (newPwd.hasError("minlength") && !newPwd.hasError("required")) {
            <mat-error>{{ "ERROR_MESSAGES.PASSWORD_MIN_LENGTH" | translate }}</mat-error>
          }
          @if (newPwd.hasError("confirmPasswordMatch")) {
            <mat-error>{{ "ERROR_MESSAGES.PASSWORDS_DONT_MATCH" | translate }}</mat-error>
          }
        </ng-container>
      }
      @if (!newPwd.hasError("required") && newPwd.hasError("oldAndNewPasswordMatch")) {
        <ng-container payee-error>
          <mat-error>{{ "PASSWORD_RESET_DIALOG.ERROR_MESSAGES.PASSWORD_MATCH" | translate }}</mat-error>
        </ng-container>
      }
    </payee-form-field>

    <payee-form-field width="max">
      <span payee-label>{{ "PASSWORD_RESET_DIALOG.CONFIRM_NEW_PASSWORD_LABEL" | translate }}</span>
      <input
        payee-input
        type="password"
        autocomplete="new-password"
        [formControl]="newPwdConfirm"
      />
      @if (newPwdConfirm.valid) {
        <div payee-suffix>
          <payee-icon name="checkmark-darker-green-circle"></payee-icon>
        </div>
      }
    </payee-form-field>

    @if (passwordForm.hasError("tooManyRequests")) {
      <mat-error>{{ "ERROR_MESSAGES.TOO_MANY_REQUESTS" | translate }}</mat-error>
    }
  </form>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="passwordForm.invalid"
      (click)="onClose()"
    >
      {{ "PASSWORD_RESET_DIALOG.BUTTONS.SAVE" | translate }}
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      color="white"
      width="max"
      mat-dialog-close
      [isBorderButton]="true"
    >
      {{ "PASSWORD_RESET_DIALOG.BUTTONS.CANCEL" | translate }}
    </button>
  </ng-template>
</payee-popup>
